import { itemUrl } from "../Config/Url";
import axios from "axios";

export const itemServices = {
  getById,
  getSearch,
  create,
  update,
  deleteItem,
  deleteItems,
  deleteAllItems,
  bulkImportValidate,
  bulkImport,
  bulkImportValidateOnboarding,
};

async function getById(priceListId, itemId) {
  return axios
    .put(`${itemUrl}`, {
      priceListId: Number(priceListId),
      itemId,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function getSearch({
  priceListId,
  storeId,
  searchName,
  pageIndex,
  pageSize,
}) {
  return axios
    .put(`${itemUrl}/search`, {
      priceListId,
      storeId,
      searchName,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create({
  tenantId,
  createInAllPriceList,
  priceListId,
  name,
  code,
  barCode,
  description,
  isService,
  pn,
  unitOfMeasureId,
  taxRateId,
  itemGroupId,
  price,
  pp,
  // new props
  isPriceLocked,
  currencyId,
  isRawMaterial,
  normativeTypeId,
  isFavorite,
  classNumber,
  inMode,
  image,
  taxExemptionReason
}) {
  return axios
    .post(`${itemUrl}`, {
      tenantId,
      createInAllPriceList,
      createPriceListData: {
        priceListId: priceListId,
        name: "",
        currencyId,
      },
      createItemData: {
        name,
        code,
        barCode,
        description,
        isService,
        pn,
        unitOfMeasureId,
        taxRateId,
        itemGroupId,
        isRawMaterial,
        normativeTypeId: normativeTypeId,
        classNumber: classNumber,
        image,
        taxExemptionReason: taxExemptionReason,
      },
      createPriceListItemData: {
        price,
        pp,
        isPriceLocked,
        isFavorite,
        inMode
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function update({
  itemId,
  priceListId,
  name,
  code,
  barCode,
  description,
  isService,
  pn,
  unitOfMeasureId,
  taxRateId,
  changePriceByTaxRate,
  itemGroupId,
  priceListItemId,
  price,
  pp,
  isPriceLocked,
  isRawMaterial,
  normativeTypeId,
  isFavorite,
  classNumber,
  inMode,
  image,
  taxExemptionReason
}) {
  return axios
    .put(`${itemUrl}/${itemId}`, {
      priceListId,
      updateItemData: {
        name,
        code,
        barCode,
        description,
        isService,
        pn,
        unitOfMeasureId,
        taxRateId,
        changePriceByTaxRate,
        itemGroupId,
        isRawMaterial,
        normativeTypeId: normativeTypeId,
        classNumber: classNumber,
        image,
        taxExemptionReason: taxExemptionReason,
      },
      updatePriceListItemData: {
        priceListItemId,
        price,
        pp,
        isPriceLocked,
        isFavorite,
        inMode
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteItem({ itemId, priceListId }) {
  return axios
    .delete(`${itemUrl}?itemId=${itemId}`, {
      priceListId,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteItems({ priceListId, items }) {
  return axios
    .delete(`${itemUrl}`, {
      data: {
        priceListId,
        items,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteAllItems({ storeId, priceListId }) {
  return axios
    .delete(
      `${itemUrl}/delete-all?storeId=${storeId}&priceListId=${priceListId}`
    )
    .then((res) => res)
    .catch((err) => err.response);
}

async function bulkImportValidate({ tenantId, priceListId, data }) {
  console.log("DDDDD", data);

  return axios
    .put(`${itemUrl}/import/validate`, {
      tenantId,
      priceListId,
      data,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function bulkImport({ tenantId, priceListId, data }) {
  return axios
    .post(`${itemUrl}/import`, {
      tenantId,
      priceListId,
      data,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function bulkImportValidateOnboarding({ params, body }) {
  return axios
    .put(`${itemUrl}/import/validate-onboarding`, body)
    .then((res) => res)
    .catch((err) => err.response);
}
